<template>
    <span class="form__control">
        <span class="form__label">{{ label }}</span>
        <div class="filter-radio">
            <label v-for="(option, index) in options" :key="index" :class="model === option.value
                ? 'filter-radio__custom-radio--active'
                : 'filter-radio__custom-radio'">
                {{ option.label }}
                <input type="radio" :name="name" v-model="model" :value="option.value" class="filter-radio__radio" />
            </label>
        </div>
    </span>
</template>

<script setup>

const props = defineProps({
    options: {
        type: Array,
        required: true,
    },
    name: {
        type: String,
        required: true,
    },
    label: {
        type: String,
        required: true,
    },
})


const model = defineModel();

</script>
